<div class="container-main">
    <!--app-header-detail></app-header-detail-->
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-contacto></app-contacto>
    <app-footer></app-footer>
</div>

<!--head>
  <style>
    .container-fluid {
      padding: 0;
      margin: 0;
    }
    .row {
      margin: 0;
      width: 100%;
      display: flex;
    }
    .col-1 {
      padding: 0;
    }
    .col-1 {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 33px;
    }
  </style>
</head>
<body>
  <div class="container-fluid">
    <div class="row">
      <div class="col-1" style="background-color: red;">1</div>
      <div class="col-1" style="background-color: blue;">2</div>
      <div class="col-1" style="background-color: red;"></div>
      <div class="col-1" style="background-color: blue;"></div>
      <div class="col-1" style="background-color: red;"></div>
      <div class="col-1" style="background-color: blue;"></div>
      <div class="col-1" style="background-color: red;"></div>
      <div class="col-1" style="background-color: blue;"></div>
      <div class="col-1" style="background-color: red;"></div>
      <div class="col-1" style="background-color: blue;">10</div>
      <div class="col-1" style="background-color: red;">11</div>
      <div class="col-1" style="background-color: blue;">12</div>
    </div>
  </div>
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>
</body-->